import type { Ref } from 'react';
import { forwardRef, useRef } from 'react';
import type { JsonDataItem } from '../generic-types';
import type { DataGridCellRenderer } from './data-grid-custom-column.interface';
import type { DataGridColumnSettings } from './data-grid-settings.interface';

export interface DataGridCustomCellProps {
  column: DataGridColumnSettings;
  data: JsonDataItem;
  components: Record<string, DataGridCellRenderer>;
}

function DataGridCustomCell({ column, data, components }: DataGridCustomCellProps, forwardRef: Ref<HTMLDivElement>) {
  if (!column.cellRenderer) throw new Error('Custom cells must have the cellRenderer property set');

  const cellRenderer = useRef(components[column.cellRenderer]);

  return cellRenderer.current ? <>{cellRenderer.current.CellComponent({ column, rowData: data }, forwardRef)}</> : null;
}

export default forwardRef(DataGridCustomCell);
